import React, { Fragment } from 'react';
import { Input } from 'semantic-ui-react';

import ErrorMessage from './errorMessage';

const HHInput = ({
  field, form: { touched, errors }, otherProps
}) => {
  const hasError = !!(touched[field.name] && errors[field.name]);

  const onKeyPress = (e) => {
    if (e.key === 'Enter' && !otherProps.allowPressEnter) {
      e.preventDefault();
    }
  };

  return (
    <Fragment>
      <Input
        type='text'
        {...field}
        {...otherProps}
        error={hasError}
        onKeyPress={onKeyPress}
      />
      {hasError && (<ErrorMessage error={errors[field.name]} />)}
    </Fragment>
  );
};

export default HHInput;



// WEBPACK FOOTER //
// ./src/components/forms/fields/hhInput.js